import Vue from "vue";
import Router from "vue-router";
import login from "@/pages/login/login.vue";
import index from "@/pages/index/index.vue";
import userList from "@/pages/index/views/userList.vue";
import libraryList from "@/pages/index/views/libraryList.vue";
import companyList from "@/pages/index/views/companyList.vue";
import numAuthority from "@/pages/index/views/numAuthority.vue";
import topicManage from "@/pages/index/views/topicManage.vue";
import hotList from "@/pages/index/views/hotList.vue";
import userAlias from "@/pages/index/views/userAlias.vue";
import userInfo from "@/pages/index/views/userInfo.vue";
import update from "@/pages/index/views/update.vue";
import menuManage from "@/pages/index/views/menuManage.vue";
import localQuery from "@/pages/index/views/localQuery.vue";
import classStatistics from "@/pages/index/views/classStatistics.vue";
import idManage from "@/pages/index/views/idManage.vue";
import section from "@/pages/index/views/section.vue";
import gacKeyWord from "@/pages/index/views/gacKeyWord.vue";
import internalUser from "@/pages/index/views/internalUser.vue";
import overseas from "@/pages/index/views/overseas.vue";
import appUser from "@/pages/index/views/appUser.vue";
import H5 from "@/pages/H5/index.vue";
import home from "@/pages/home/home.vue";
import privacyPolicy from "@/pages/home/privacyPolicy";
import err404 from "@/pages/index/views/404.vue";
import appdownload from "@/pages/appdownload/index.vue";
import identify from "@/pages/identify/index.vue";
import imgIdentify from "@/pages/identify/views/imgIdentify.vue";
import videoIdentify from "@/pages/identify/views/videoIdentify.vue";
import realTime from "@/pages/identify/views/realTime.vue";
import HbaseSearch from "@/pages/identify/views/HbaseSearch.vue";
import docList from "@/pages/identify/views/docList.vue";
import frontProJect from "@/pages/frontProJect/index.vue";
// 更新日志
import UpdateJournal from "@/pages/index/views/UpdateJournal";
// 风险舆情页面
import trialUser from "@/pages/index/riskViews/trialUser";
import formalUser from "@/pages/index/riskViews/formalUser";
import userRole from "@/pages/index/riskViews/userRole";
import industrySet from "@/pages/index/riskViews/industrySet";

Vue.use(Router);

export default new Router({
  // mode:'history',
  routes: [
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "*",
      redirect: "/404"
    },
    {
      path: "/login",
      name: "login",
      component: login,
      meta: {
        title: "登陆"
      }
    },
    {
      path: "/index",
      name: "index",
      component: index,
      // redirect: '/home',
      children: [
        {
          path: "/userList",
          name: "用户列表",
          icon: "el-icon-user-solid",
          component: userList,
          meta: {
            authorName: "sys:syzh:backstage:user",
            authority: false,
            type: "aUser"
          }
        },
        // { path: "/userAlias",name: "用户别名映射",icon:"el-icon-s-management",component: userAlias,meta:{authorName:"sys:syzh:backstage:userMap",authority: false,type:"aUser"} },
        {
          path: "/internalUser",
          name: "内部用户管理",
          icon: "el-icon-user",
          component: internalUser,
          meta: {
            authorName: "sys:syzh:backstage:wxUser",
            authority: false,
            type: "aUser"
          }
        },
        {
          path: "/updateJournal",
          name: "更新日志",
          icon: "el-icon-user",
          component: UpdateJournal,
          meta: {
            authorName: "",
            authority: false,
            type: "updateJ"
          }
        },
        {
          path: "/appUser",
          name: "app用户管理",
          icon: "el-icon-mobile-phone",
          component: appUser,
          meta: {
            authorName: "sys:syzh:backstage:wxUser",
            authority: false,
            type: "aUser"
          }
        },
        {
          path: "/companyList",
          name: "公司列表",
          icon: "el-icon-s-promotion",
          component: companyList,
          meta: {
            authorName: "sys:syzh:backstage:company",
            authority: false,
            type: "bCompany"
          }
        },
        {
          path: "/numAuthority",
          name: "公司权限管理",
          icon: "el-icon-s-help",
          component: numAuthority,
          meta: {
            authorName: "sys:syzh:backstage:numberPermission",
            authority: false,
            type: "bCompany"
          }
        },
        {
          path: "/section",
          name: "部门管理",
          icon: "el-icon-office-building",
          component: section,
          meta: {
            authorName: "sys:syzh:backstage:dept",
            authority: false,
            type: "bCompany"
          }
        },
        {
          path: "/topicManage",
          name: "专题管理",
          icon: "el-icon-s-operation",
          component: topicManage,
          meta: {
            authorName: "sys:syzh:backstage:classManage",
            authority: false,
            type: "cClass"
          }
        },
        {
          path: "/localQuery",
          name: "专题进数查询",
          icon: "el-icon-search",
          component: localQuery,
          meta: {
            authorName: "sys:syzh:backstage:localQuery",
            authority: false,
            type: "cClass"
          }
        },
        {
          path: "/classStatistics",
          name: "分类统计",
          icon: "el-icon-data-analysis",
          component: classStatistics,
          meta: {
            authorName: "sys:syzh:backstage:statistics",
            authority: false,
            type: "cClass"
          }
        },
        // { path: "/hotList",name: "今日热榜配置",component: hotList,meta:{authority: false} },
        {
          path: "/menuManage",
          name: "目录管理",
          icon: "el-icon-document-copy",
          component: menuManage,
          meta: {
            authorName: "sys:syzh:backstage:catalog",
            authority: false,
            type: "dSite"
          }
        },
        {
          path: "/idManage",
          name: "站点管理",
          icon: "el-icon-set-up",
          component: idManage,
          meta: {
            authorName: "sys:syzh:backstage:site",
            authority: false,
            type: "dSite"
          }
        },
        {
          path: "/libraryList",
          name: "敏感词库",
          icon: "el-icon-warning",
          component: libraryList,
          meta: {
            authorName: "sys:syzh:backstage:sensitivity",
            authority: false,
            type: "eKeyWord"
          }
        },
        {
          path: "/gacKeyWord",
          name: "广汽关键词管理",
          icon: "el-icon-key",
          component: gacKeyWord,
          meta: {
            authorName: "sys:syzh:backstage:gacKeyWord",
            authority: false,
            type: "eKeyWord"
          }
        },
        {
          path: "/update",
          name: "APP更新",
          icon: "el-icon-upload",
          component: update,
          meta: { authorName: "sys:syzh:backstage:AppEdit", authority: false }
        },
        {
          path: "/userInfo",
          name: "后台设置",
          icon: "el-icon-s-operation",
          component: userInfo,
          meta: { authorName: "sys:syzh:backstage:UC", authority: false }
        },
        {
          path: "/overseas",
          name: "境外网站管理",
          icon: "el-icon-position",
          component: overseas,
          meta: { authorName: "sys:syzh:backstage:AppEdit", authority: false }
        },
        {
          path: "/trialUser",
          name: "试用客户",
          icon: "icon-shiyongkehu",
          component: trialUser,
          meta: { authorName: "1", authority: false, type: "fUserManage" }
        },
        {
          path: "/formalUser",
          name: "客户列表",
          icon: "icon-n-zhengshikehu",
          component: formalUser,
          meta: { authorName: "2", authority: false, type: "fUserManage" }
        },
        {
          path: "/userRole",
          name: "客户角色",
          icon: "icon-jiaose",
          component: userRole,
          meta: { authorName: "3", authority: false, type: "fUserManage" }
        },
        {
          path: "/industrySet",
          name: "行业设置",
          icon: "icon-ptkj-hangyeshezhi",
          component: industrySet,
          meta: { authorName: "4", authority: false, type: "fUserManage" }
        }
      ]
    },
    {
      path: "/dayReport",
      name: "广发产品日报舆情",
      component: H5
    },
    {
      path: "/home",
      name: "蓝鹰舆情",
      component: home
    },
    {
      path: "/privacyPolicy",
      name: "隐私政策",
      component: privacyPolicy
    },
    {
      path: "/404",
      name: "404",
      component: err404
    },
    {
      path: "/download",
      name: "appdownload",
      component: appdownload
    },
    {
      path: "/frontProJect",
      name: "项目模板结构说明",
      component: frontProJect
    },
    // {
    //   path: "/imgIdentify",
    //   name: 'imgIdentify',
    //   component: imgIdentify
    // },
    {
      path: "/identify",
      name: "identify",
      component: identify,
      // redirect: '/home',
      children: [
        { path: "/imgIdentify", name: "图片识别列表", component: imgIdentify },
        {
          path: "/videoIdentify",
          name: "视频识别列表",
          component: videoIdentify
        },
        { path: "/docList", name: "文档列表", component: docList },
        { path: "/realTime", name: "实时识别", component: realTime },
        { path: "/Hbase", name: "Hbase查询", component: HbaseSearch }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js